
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, toRefs} from 'vue'
    import {useStore} from "@/store";
    import common from "@/util/common";


    // interface State {
    // }
    export default defineComponent({
        name: "ensureService",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            // let state: State = reactive({
            // })
            // state.reportMsg = reportMsgUt;
            let store = useStore()
            // 获取路由器实例
            const router = useRouter()
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
            return {
                // state,
                router,
                store,
                getData
            }
        },
        methods: {
            toView(code){
                let getCcode = this.getData(code);
                let path = getCcode.charAt(0).toUpperCase() + getCcode.slice(1).replace('_', '');
                // console.log('this.getData(code):', code);
                this.store.dispatch('savePageScrollTop', window.scrollY);
                this.router.push({
                    path: `/batteryFrame${path}`,
                })
            },
        }
    })
